import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { evidenceAccept, tribunalType, trialStatus, trialRoleType, evidenceUploadStatus, evidenceUploadStatusText } from '@/config/dic';
import { toChineseNum } from '@/utils/index';
import UploadConfig from '@/class/upload.config';
import upload from '@/apis/upload';
import EvidenceCard from './EvidenceCard.vue';
var uploadConfigIns = new UploadConfig(); // 定时更新证据材料

var timer = null;

var EvidenceList = /*#__PURE__*/function (_Vue) {
  _inherits(EvidenceList, _Vue);

  var _super = _createSuper(EvidenceList);

  function EvidenceList() {
    var _this;

    _classCallCheck(this, EvidenceList);

    _this = _super.call(this);
    _this.activeName = trialRoleType.judge; // private startTime: number

    _this.limit = 500;
    _this.fileList = [];
    _this.beforeFiles = 0;
    _this.beforeUpFiles = 0;
    _this.maxUpFiles = 4; // this.startTime = 0

    _this.accept = evidenceAccept; // this.isReupload = false

    _this.trialCount = 0;
    _this.activeId = '';
    _this.visible = false;
    _this.trialList = {
      judge: [],
      plaintiff: [],
      defendant: [],
      third: []
    };
    return _this;
  }

  _createClass(EvidenceList, [{
    key: "changeStartTime",
    value: function changeStartTime(val) {
      this.trialCount = val.length - 1;
      this.trialList = this.trials[val.length - 1];
    }
  }, {
    key: "changeFileList",
    value: function changeFileList(val, oldVal) {
      if (val.length > this.beforeFiles) {
        this.visible = true;
      }

      this.beforeFiles = val.length; // old方式监听失效
      // const beforeFiles = oldVal.filter(o => o.status === evidenceUploadStatus.uploading)

      var files = val.filter(function (v) {
        return v.status === evidenceUploadStatus.uploading;
      });

      if (this.beforeUpFiles > files.length && files.length < this.maxUpFiles) {
        this.beforeUpFiles = files.length;
        var readyFiles = val.filter(function (v) {
          return v.status === evidenceUploadStatus.ready;
        });

        for (var i = 0; i < this.maxUpFiles - files.length && i < readyFiles.length; i++) {
          // readyFiles[i].startTime = 0;
          this.$refs.upload.reupload(readyFiles[i].file);
        }
      } else {
        this.beforeUpFiles = files.length;
      }
    }
  }, {
    key: "getFiles",
    value: function getFiles() {} // 开始更新证据材料事件

  }, {
    key: "startUpdateTrials",
    value: function startUpdateTrials() {} // 停止更新证据材料事件

  }, {
    key: "stopUpdateTrials",
    value: function stopUpdateTrials() {} // @Emit('getImageUrl')

  }, {
    key: "getImageUrl",
    value: function getImageUrl(url, type, id) {
      this.activeId = id;
    }
  }, {
    key: "trialCountChange",
    value: function trialCountChange(val) {
      this.trialList = this.trials[val];
    }
  }, {
    key: "deleteCase",
    value: function deleteCase(id) {
      var _this2 = this;

      this.$confirm('是否删除该文件记录？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function () {
        upload.deleteFile({
          id: id,
          caseId: _this2.caseId,
          mobile: _this2.$store.getters.userInfo.userName
        }).then(function (res) {
          _this2.getFiles(); // this.getImageUrl('', '', '')


          _this2.$message.success('删除成功');

          _this2.$emit('getImageUrl', _this2.getImageUrl('', '', ''));
        }).catch(function (_) {
          _this2.$message.error('删除失败');
        });
      });
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(index, rows) {
      this.$refs.upload.abort(rows[index].file);
      this.$nextTick(function () {
        rows.splice(index, 1);
      }); // this.startTime = 0; 都删除了不必重置
    }
  }, {
    key: "reupload",
    value: function reupload(index, rows) {
      // this.startTime = 0;
      // this.isReupload = true;
      rows[index].startTime = 0;
      rows[index].isReupload = true;
      rows[index].status = evidenceUploadStatus.ready;
      this.$refs.upload.reupload(rows[index].file);
    }
  }, {
    key: "countSize",
    value: function countSize(size) {
      return uploadConfigIns.countSize(size);
    } // 文件超出个数限制时的钩子

  }, {
    key: "uploadExceed",
    value: function uploadExceed() {}
  }, {
    key: "uploadBefore",
    value: function uploadBefore(file) {
      var res = uploadConfigIns.beforeUpload(file, true); // 正在上传中文件

      var uploadingFiles = this.fileList.filter(function (f) {
        return f.status === evidenceUploadStatus.uploading;
      });
      var findInd = uploadingFiles.find(function (f) {
        return f.uid === file.uid;
      });

      if (!res || !findInd && this.maxUpFiles <= uploadingFiles.length) {
        // 文件大小不符 || 文件状态非上传中且当前文件上传
        this.$refs.upload.abort(file); // if (!findInd && this.maxUpFiles <= uploadingFiles.length) {
        //   this.visible = true
        // }
      } else {
        var findUpInd = this.fileList.find(function (f) {
          return f.uid === file.uid;
        });
        findUpInd.status = evidenceUploadStatus.uploading; // this.visible = true
      }

      return res && (findInd || this.maxUpFiles > uploadingFiles.length);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(event, file, fileList) {
      var res = uploadConfigIns.beforeUpload(file); // console.log('pre', this.fileList)

      if (res) {
        var timeStamp = new Date().getTime();
        var findInd = this.fileList.find(function (o) {
          return o.uid === file.uid;
        });
        var ind = findInd !== undefined ? this.fileList.indexOf(findInd) : -1;
        this.fileList[ind].percent = Math.floor(event.percent);

        if (timeStamp - (findInd.startTime || 0) >= 1) {
          this.fileList[ind].velocity = uploadConfigIns.computeVelocity(event.loaded, timeStamp, findInd.startTime || 0);
        }

        if (!findInd.isReupload) {
          this.fileList[ind].percentSize = event.loaded < file.size ? event.loaded : file.size;
        } else {
          if (this.fileList[ind].status === evidenceUploadStatus.success) {
            this.fileList[ind].percentSize = file.size;
          } else {
            this.fileList[ind].percentSize = event.loaded < file.size ? event.loaded : file.size;
          }
        }

        findInd.startTime = timeStamp;
      } // console.log('next', this.fileList)

    }
  }, {
    key: "uploadChange",
    value: function uploadChange(file, fileList) {
      var res = uploadConfigIns.beforeUpload(file);

      if (res) {
        // 判断接口返回值更新文件状态(更新未失败或上云中)
        if (file.status === evidenceUploadStatus.success) {
          if (file.response.code !== '0') {
            file.status = evidenceUploadStatus.fail;
          } else {
            file.status = evidenceUploadStatus.uploadCloud;
            file.taskId = file.response.data;
          }
        }

        var findInd = this.fileList.find(function (o) {
          return o.uid === file.uid;
        });
        var ind = findInd !== undefined ? this.fileList.indexOf(findInd) : -1;
        var obj = {
          file: file.raw,
          uid: file.uid,
          name: file.name,
          size: file.size,
          status: file.status,
          url: file.url,
          percentSize: this.fileList[ind] ? this.fileList[ind].percentSize : 0,
          percent: this.fileList[ind] ? this.fileList[ind].percent : 0,
          velocity: this.fileList[ind] ? this.fileList[ind].velocity : '',
          startTime: new Date().getTime(),
          isReupload: false
        };

        if (file.taskId) {
          obj.taskId = file.taskId;
        } // this.startTime = new Date().getTime();


        if (ind !== -1) {
          this.fileList.splice(ind, 1, obj);
        } else {
          this.fileList.push(obj);
        }
      }
    }
  }, {
    key: "uploadSuccess",
    value: function uploadSuccess(response, file, fileList, xhr) {
      var findInd = this.fileList.find(function (f) {
        return f.uid === file.uid;
      });

      if (response.code === '0') {
        findInd.isReupload = false; // this.getFiles()
      } else {
        this.$message.error(response.msg);
      }
    } // 获取当前上云中的任务

  }, {
    key: "getUploadCloud",
    value: function getUploadCloud() {
      var str = '';
      var uploadCloudList = this.fileList.filter(function (item) {
        return item.status === evidenceUploadStatus.uploadCloud;
      });

      if (uploadCloudList && uploadCloudList.length) {
        str = uploadCloudList.map(function (item) {
          return item.taskId;
        }).join(',');
      }

      return str;
    } // 查询当前正在上云任务是否已完成

  }, {
    key: "checkFileTaskIds",
    value: function checkFileTaskIds() {
      var _this3 = this;

      var taskIds = this.getUploadCloud();

      if (taskIds) {
        upload.checkFileTaskIds({
          taskIds: taskIds
        }).then(function (res) {
          _this3.updateFileList(res.data.list || []);

          _this3.startUpdateTrials();
        }).catch(function (_) {});
      } else {
        this.stopUpdateTrials();
      }
    } // 更新FileList，主要更新file的status

  }, {
    key: "updateFileList",
    value: function updateFileList(list) {
      var _this4 = this;

      list.forEach(function (task) {
        _this4.fileList.forEach(function (file, index) {
          if (file.status === evidenceUploadStatus.uploadCloud && task.taskId === file.taskId) {
            if (task.fileStatus === '0') {
              _this4.fileList[index].status = evidenceUploadStatus.success;
            } else if (task.fileStatus === '2') {
              _this4.fileList[index].status = evidenceUploadStatus.fail;
            }
          }
        });
      });
    } // 定时更新任务列表任务状态

  }, {
    key: "checkFileTaskIdsTimer",
    value: function checkFileTaskIdsTimer() {
      var _this5 = this;

      if (timer) {
        clearInterval(timer);
        timer = null;
      }

      timer = setInterval(function () {
        _this5.checkFileTaskIds();
      }, 5 * 1000);
      this.$on('hook:beforDestroy', function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.checkFileTaskIdsTimer();
    }
  }, {
    key: "trialRoleType",
    get: function get() {
      return trialRoleType;
    }
  }, {
    key: "evidenceUploadStatus",
    get: function get() {
      return evidenceUploadStatus;
    }
  }, {
    key: "evidenceUploadStatusText",
    get: function get() {
      return evidenceUploadStatusText;
    }
  }, {
    key: "options",
    get: function get() {
      var option = [];

      for (var i = 0; i < this.trials.length; i++) {
        var str = toChineseNum(i + 1);
        var label = "\u7B2C".concat(str, "\u6B21\u5EAD\u5BA1");
        var params = {
          value: i,
          label: label
        };
        option.push(params);
      }

      return option;
    }
  }, {
    key: "uploadCount",
    get: function get() {
      var count = 0;
      var list = this.fileList;

      for (var i = 0; i < list.length; i++) {
        if (list[i].status === evidenceUploadStatus.ready || list[i].status === evidenceUploadStatus.uploading || list[i].status === evidenceUploadStatus.uploadCloud) {
          count++;
        }
      }

      return count;
    }
  }, {
    key: "uploadHeaders",
    get: function get() {
      return uploadConfigIns.headers;
    }
  }, {
    key: "uploadData",
    get: function get() {
      return {
        userId: this.$store.getters.userInfo.userId,
        caseId: this.caseId,
        realName: this.$store.getters.userInfo.userName,
        name: this.$store.getters.userInfo.reallyName
      };
    } // 是否可以进行删除及上传

  }, {
    key: "canHandle",
    get: function get() {
      return this.trials.length ? this.trialCount === this.trials.length - 1 && this.caseStatus !== trialStatus.filed : true;
    }
  }, {
    key: "showNameMap",
    get: function get() {
      return this.$store.getters.showNameMap;
    }
  }, {
    key: "isArbitration",
    get: function get() {
      return this.$store.getters.tribunalType === tribunalType.arbitration;
    }
  }]);

  return EvidenceList;
}(Vue);

__decorate([Prop({
  type: Array,
  default: []
})], EvidenceList.prototype, "trials", void 0);

__decorate([Prop({
  type: String,
  required: true,
  default: ''
})], EvidenceList.prototype, "caseId", void 0);

__decorate([Prop({
  type: String,
  required: true,
  default: ''
})], EvidenceList.prototype, "caseStatus", void 0);

__decorate([Watch('trials', {
  deep: true
})], EvidenceList.prototype, "changeStartTime", null);

__decorate([Watch('fileList', {
  deep: true
})], EvidenceList.prototype, "changeFileList", null);

__decorate([Emit('getFiles')], EvidenceList.prototype, "getFiles", null);

__decorate([Emit('startUpdateTrials')], EvidenceList.prototype, "startUpdateTrials", null);

__decorate([Emit('stopUpdateTrials')], EvidenceList.prototype, "stopUpdateTrials", null);

EvidenceList = __decorate([Component({
  components: {
    EvidenceCard: EvidenceCard
  }
})], EvidenceList);
export default EvidenceList;